import React from "react";
import { Container, Loader, Segment } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";
import CustomLoader from "../CustomLoader";

interface ITemplateMainProps {
    loading: boolean;
    content: React.ReactNode;
}

const TemplateMain: React.FC<ITemplateMainProps> = (props) => {

    return (
        <>
            <AliancaMenu />
            <Container className="swing-in-bottom-bck app-margin">
                {props.loading ? <Segment> <CustomLoader /> </Segment> : props.content}
            </Container>
            <Footer />
        </>
    );
}

export default TemplateMain;
